import { FC } from "react";
import { Typography } from "@mui/material";
import { AppModal } from "../../../../../../components/ui";

type Props = {
    openActive: boolean;
    onCloseActive: () => void;
    openInfo: boolean;
    onCloseInfo: () => void;
};

/** Diálogos informativos da etapa de definições (busca por ativos / filtros). */
const DefinitionsDialogs: FC<Props> = ({ openActive, onCloseActive, openInfo, onCloseInfo }) => (
    <>
        <AppModal
            open={openActive}
            onClose={onCloseActive}
            kicker="Informação"
            title="Troque a busca por classes pela busca por ativos"
            maxWidth={460}
        >
            <Typography sx={{ fontSize: "14.5px", color: "text.secondary", lineHeight: 1.6 }}>
                Selecione essa opção caso já tenha em mente quais ativos precisa usar para essa formulação.
            </Typography>
        </AppModal>

        <AppModal
            open={openInfo}
            onClose={onCloseInfo}
            kicker="Informação"
            title="Informação sobre os botões"
            maxWidth={460}
        >
            <Typography sx={{ fontSize: "14.5px", color: "text.secondary", lineHeight: 1.6 }}>
                Ative os botões para a direita para ativar os filtros de paciente gestante, produtos veganos/orgânicos/cruelty free. Somente
                ativos filtrados irão aparecer na sua consulta.
            </Typography>
        </AppModal>
    </>
);

export default DefinitionsDialogs;
